interface SkeletonCardProps {
  variant?: "parcours" | "module" | "kpi" | "session";
  className?: string;
}

/**
 * Skeleton loader for cards in the stats views
 * - parcours/module: Visual card with thumbnail placeholder (180x120)
 * - kpi: Stats card with icon and value placeholder
 * - session: Session card placeholder with shimmer effect
 */
const SkeletonCard = ({ variant = "parcours", className = "" }: SkeletonCardProps) => {
  if (variant === "kpi") {
    return (
      <div className={`bg-white rounded-xl border border-gray-200 p-5 shadow-sm ${className}`}>
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="h-4 w-24 skeleton-shimmer rounded mb-3" />
            <div className="h-8 w-16 skeleton-shimmer rounded" />
          </div>
          <div className="w-12 h-12 skeleton-shimmer rounded-xl" />
        </div>
      </div>
    );
  }

  if (variant === "session") {
    return (
      <div
        className={`relative rounded-xl overflow-hidden border border-gray-200 p-4 ${className}`}
      >
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full skeleton-shimmer" />
            <div>
              <div className="h-4 w-32 skeleton-shimmer rounded mb-2" />
              <div className="h-3 w-20 skeleton-shimmer rounded" />
            </div>
          </div>
          <div className="h-6 w-20 skeleton-shimmer rounded-full" />
        </div>
        <div className="flex items-center gap-4">
          <div className="h-10 w-24 skeleton-shimmer rounded-lg" />
          <div className="h-5 w-16 skeleton-shimmer rounded" />
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 skeleton-shimmer" />
      </div>
    );
  }

  return (
    <div
      className={`relative rounded-xl overflow-hidden shadow ${className}`}
      style={{ width: "180px", height: "120px" }}
    >
      <div className="absolute inset-0 skeleton-shimmer" />

      <div className="absolute top-2 right-2">
        <div className="w-8 h-6 bg-gray-300/50 rounded-lg" />
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-3">
        <div className="h-4 w-3/4 bg-gray-300/50 rounded mb-1" />
        <div className="h-3 w-1/2 bg-gray-300/50 rounded" />
      </div>
    </div>
  );
};

export default SkeletonCard;
